import schema from '@/nebula/schema';
import { findIndex } from 'lodash-es';
import { update as updateConfig } from 'shared/api/query/configs.json';

export const updateGoalActivitiesCount = (state, goalActivities) => {
  const goals = goalActivities.map((ga) => ga.goal);
  goals.forEach((g) => {
    const index = findIndex(state.goals, (goal) => goal.uid === g.uid);
    if (index === -1) {
      return;
    }
    state.goals[index].goalActivityCount += 1;
  });
};

// TODO: remove once goals is in nebula
export const addUpdates = (commit, updates) => {
  commit('nebula/MUTATE', { entities: updates, model: updateConfig.model, schema });
};
